import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux';
import MultiUpload from './MultiUpload';
import { useProductPics } from '../hooks/useProductPics';
import Input from './UI/Input/Input'
import { define, tokenExpiredMsg, expNotifyDuration } from '../data/globals'
import MyEditor from './UI/MyEditor/MyEditor'
import { useNotify } from '../hooks/useNotify';


const ProdFormUpdate = (props) => {
    const updProdStore = useSelector(state => state.updProd)
    const picsInDBStore = useSelector(state => state.picsInDB)
    const newPicsStore = useSelector(state => state.newPics)
    const dispath = useDispatch()
    const getProductPics = useProductPics()
    const [isFilled1, setIsFilled1] = useState(false)
    const [isFilled2, setIsFilled2] = useState(false)
    const { pushNotify } = useNotify()


    function inputName(event) {
        dispath({ type: 'SetTypedPName', name: event.target.value })
        // // сняте подсветки, если поле заполнено
        // if(event.target.value.length > 0) setIsFilled1(false);
        // else setIsFilled1(true)
    }
    // // Для простого инпута:
    // function inputDescr(event) {
    //     dispath({ type: 'SetTypedPDescr', description: event.target.value} )
    //     // // сняте подсветки, если поле заполнено
    //     // if(event.target.value.length > 0) setIsFilled2(false);
    //     // else setIsFilled2(true)
    // }
    // Для tinyMCE редактора:
    function inputDescr(editorText) {
        dispath({ type: 'SetTypedPDescr', description: editorText })
    }

    let filteredValue
    function inputPrice(e) {
        // оставляем только цыфры и точку
        filteredValue = e.target.value.replace(/[^.\d]+/g,"").replace( /^([^.]*\.)|\./g, '$1' )
        dispath({ type: 'SetTypedPPrice', price: filteredValue})
    }

    function checkForm(e) {
        e.preventDefault()
        let pointsToGo = 2
        // подсветка пустых полей
        if(updProdStore.name.length === 0) { setIsFilled1(true); pointsToGo-- }
        if(updProdStore.description.length === 0) { setIsFilled2(true); pointsToGo-- }
        // Поля заполнены - сохраняем товар
        (pointsToGo === 2) ? updateProduct()
            : pushNotify("Заполните обязательные поля,<br>чтобы сохранить товар", "notifyRed")
            // : props.pushNotify("Заполните обязательные поля,<br>чтобы сохранить товар", "notifyRed")
    }

    async function updateProduct() {

        let correctedPrice = Number(updProdStore.price).toFixed(2)
        // Округление цены
        dispath({ type: 'SetTypedPPrice', price: correctedPrice})
    
        try {
            // Изображения в сторе + новые
            const sumPics = [...picsInDBStore, ...newPicsStore]

            const response = await axios({
                method: 'post',
                url: define.pathToAPI + '/products/update.php',
                data: JSON.stringify({
                    id: updProdStore.id,
                    name: updProdStore.name,
                    description: updProdStore.description,
                    pictures: sumPics,
                    price: correctedPrice,
                    userToken: localStorage.getItem('AuthToken'),
                }),
            })

            // проверка ответа от update.php
            switch(response.data.message){
                case 'Товар обновлён':
                    // #####################################################################
                    // Сделано: удаление picsToDelete файлов ПОСЛЕ обновления товара в базе. 
                    // Протестить!
                    // #####################################################################
                    // Удаление picsToDelete файлов
                    props.delPics()
                    props.update()
// #####################################################################
                    // Получение списка изображений (по id товара)
                    getProductPics(updProdStore.id)
// #####################################################################
                    break
                case 'Токен устарел!':
                    pushNotify(tokenExpiredMsg, "notifyWelcome", expNotifyDuration)
                    // props.pushNotify(tokenExpiredMsg, "notifyWelcome", expNotifyDuration)
                    // ########################################################
                    // При блокировке доступа, удалить картинки, которые не были сохранены в базе
                    // ########################################################
                    break
                case 'Токены не совпадают! Доступ запрещен':
                    pushNotify("Токены не совпадают! Alarm! Доступ запрещен", "notifyWelcome")
                    // props.pushNotify("Токены не совпадают! Alarm! Доступ запрещен", "notifyWelcome")
                    // ########################################################
                    // При блокировке доступа, удалить картинки, которые не были сохранены в базе
                    // ########################################################
                    break
                default:
                    console.log('Ошибка при обновлении товара.\nСервер отвечает (код 200). Но нет подтверждения от update.php, что товар обновлен')
                    console.log(response)
                    alert('Ошибка при обновлении товара (см.  консоль)')
                    break
            } // switch

//             if(response.data.message === 'Товар обновлён') {
//                 // #####################################################################
//                 // Сделано: удаление picsToDelete файлов ПОСЛЕ обновления товара в базе. 
//                 // Протестить!
//                 // #####################################################################
//                 // Удаление picsToDelete файлов
//                 props.delPics() // this.$refs.uplModule.delPicsToDelete()
//                 props.update() // this.$emit('update')
// // #####################################################################
//                 // Получение списка изображений (по id товара)
//                 getProductPics(updProdStore.id) // this.$store.commit('setPicsArray')
// // #####################################################################
//             } else {
//                 console.log('Ошибка при обновлении товара.\nСервер отвечает (код 200). Но нет подтверждения от update.php, что товар обновлен')
//                 console.log(response)
//                 alert('Ошибка при обновлении товара (см.  консоль)')
//             }

        } catch (e) {
            if(e === 'AxiosError: Request failed with status code 400') {
                console.log('Ошибка при обновлении товара.\nКод: 400 - Некорректный ID\n(см. update.php)')
                alert('Ошибка (код: 400) при обновлении товара (см.  консоль)')
            } else {
                alert('Ошибка при обновлении товара.\n' + e)
                console.log(e)
            }
        }// try
        
    }// updateProduct

    useEffect(()=>{
        // подсветка пустого поля
        if(updProdStore.name.length > 0) setIsFilled1(false)
        else setIsFilled1(true)
        // eslint-disable-next-line react-hooks/exhaustive-deps        
    }, [updProdStore.name])

    useEffect(()=>{
        // подсветка пустого поля
        if(updProdStore.description.length > 0) setIsFilled2(false)
        else setIsFilled2(true)
        // eslint-disable-next-line react-hooks/exhaustive-deps        
    }, [updProdStore.description])

    return (
        <div className={ isFilled2 ? 'alarm-on' : 'alarm-off' }>
            <h1>{ props.header }</h1>
            {(updProdStore.id > 0) ?
                <div>
                    <p className='mb-10'>Категория: <b>{ updProdStore.categoryName }</b></p>
                    ID товара: <b>{ updProdStore.id }</b><br/>

                    <form className="mt-10">
                        Название:<br/>
                        <Input
                            className={`form-input w540 ${(isFilled1) ? "notfilled" : ""}`}
                            value={ updProdStore.name }
                            onChange={ inputName }
                        />
                        <div className="tooltip mb-10">
                        { isFilled1 && <div className="tooltiptext ml-90 mt-7">Заполните название</div> }
                        </div>

                        <MultiUpload />
                        Цена:
                        <Input
                            className={`form-input w100 text-center ml-10 mr-4 mb-10`}
                            value={ updProdStore.price }
                            onChange={ inputPrice }
                            placeholder=""
                        /> грн.<br/>
                        
                        Описание:<br/>
                        <MyEditor
                            value={ updProdStore.description }
                            onEditorChange={ inputDescr }
                        />
                        <div className="tooltip mb-15">
                        { isFilled2 && <div className="tooltiptext ml-90 mt-m20">Заполните описание</div> }
                        </div>

                        <button onClick={ checkForm } className='btn greenBtn'>Сохранить</button>
                    </form><br/>
                </div>
            : <div>Выберите товар для редактирования</div>
            }

        </div>
    )
}

export default ProdFormUpdate